/**
 * @file
 * Navigation script.
 */

(function navigationScript($, Drupal, _) {
  'use strict';

  var isMobileMenuOpen = false;

  // Utility function to resolve on/off classes.
  var navbarActionClasses = function ($element) {
    return {
      on: 'navigation--white-bg',
      off: $element.data('navOffClass') || 'navigation--trans-bg'
    };
  };

  /*
   * Navbar
   */
  Drupal.behaviors.navigationNavbar = {
    attach: function (context) {
      var $navbar = $('.navigation', context);
      var $header = $('.header', context);
      var topicNavCheck = $('.topic-navigator', context).length;
      var $siteHeader = $('.site__header', context);
      var $hasMessagesTabs = $('.site__utility', context).find('#block-tabs, .message').length !== 0;

      if (!$navbar.length) {
        return;
      }

      $('.u-no--click-through', context).on('click', function (e) {
        e.preventDefault();
      });

      if (topicNavCheck && $(window).width() < 768) {
        $navbar
          .attr('data-nav-overlay', 'false')
          .addClass('navigation--white-bg ')
          .removeClass('navigation--trans-bg');
        $siteHeader
          .removeClass('site__header--fixed-nav')
          .addClass('site__header--secondary-fixed-nav');
      }
      else {
        // Set navbar to overlay if header has background.
        // Do not do this if there are tabs or a message in between the header and the navigation.
        if ($header.attr('data-has-bg') === 'true' && !$hasMessagesTabs) {
          $navbar
            .attr('data-nav-overlay', 'true')
            .addClass('navigation--trans-bg')
            .removeClass('navigation--white-bg');
        }

        // Save class to restore when not active.
        $navbar.attr('data-nav-off-class', $navbar.hasClass('navigation--white-bg') ? 'navigation--white-bg' : 'navigation--trans-bg');
      }

      // Apply the proper background to navbar using scrolling data attributes.
      $(window).on('scroll', _.debounce(function () {

        // If main menu is not expanded on mobile.
        if (!$('body').hasClass('u-noscroll')) {

          var actionClasses = navbarActionClasses($navbar);

          // If menu is not in position 0 (top).
          if ($(this).scrollTop() > 0) {

            if ($navbar.attr('data-nav-overlay') === 'true') {
              // Set navigation bar white overlay.
              $navbar
                .attr('data-nav-scrolling', 'true')
                .addClass(actionClasses.on)
                .removeClass(actionClasses.off);
            }
            else {
              $navbar
                .attr('data-nav-scrolling', 'true');
            }
          }
          else {
            if ($navbar.attr('data-nav-overlay') === 'true' && $(this).scrollTop() > 0) {
              // If menu is in position 0, remove uneeded attributes and add relevant classes.
              $navbar.removeAttr('data-nav-scrolling').removeClass(actionClasses.on).addClass(actionClasses.off);
            }
            else {
              $navbar.removeAttr('data-nav-scrolling');
            }
          }
        }
      }, 15));

      // Only apply background changes on hover if not scrolling.
      $navbar.hover(function () {
        var $t = $(this);
        if ($t.attr('data-nav-scrolling') === 'true') {
          return;
        }
        else if ($t.attr('data-nav-overlay') === 'false') {
          return;
        }
        else if (topicNavCheck && $(window).width() < 768) {
          return;
        }
        else {
          var actionClasses = navbarActionClasses($t);
          $t
            .addClass(actionClasses.on)
            .removeClass(actionClasses.off);
        }
      }, function () {
        var $t = $(this);
        if ($t.attr('data-nav-scrolling') === 'true') {
          return;
        }
        else if ($t.attr('data-nav-overlay') === 'false') {
          return;
        }
        else if (topicNavCheck && $(window).width() < 768) {
          return;
        }
        else {
          var actionClasses = navbarActionClasses($t);
          if (!isMobileMenuOpen) {
            $t
              .addClass(actionClasses.off)
              .removeClass(actionClasses.on);
          }
        }
      });

      if ($('.navigation').hasClass('navigation--white-bg') && !$siteHeader.hasClass('site__header--secondary-fixed-nav')) {
        $siteHeader.addClass('site__header--fixed-nav');
      }

      // Resize
      $(window).on('resize', _.throttle(function windowResize() {
        if ($(this).width() >= 768) {
          $siteHeader.removeClass('site__header--secondary-fixed-nav');
        }
        else if (topicNavCheck) {
          $navbar
            .attr('data-nav-overlay', 'false')
            .addClass('navigation--white-bg ')
            .removeClass('navigation--trans-bg');
          $siteHeader
            .removeClass('site__header--fixed-nav')
            .addClass('site__header--secondary-fixed-nav');
        }

        if ($('.menu__toggle').css('display') === 'none') {
          $('.navigation .desktop').css('display', 'block');

          // Set primary and dependent offsets.
          var navHeight = $('.navigation').height();
          var navTop = $('.navigation').position().top;
          $('header.site__header--fixed-nav').css('padding-top', navHeight);
          $('.submenu').css({top: navTop + navHeight + 1});
        }
        else {
          $('.navigation .desktop').css('display', 'none');

          // Reset primary offset.
          $('header.site__header--fixed-nav').css('padding-top', '52px');
        }

        // Match the tools menu height with the main menu height.
        // Note: this assumes the tools menu will always be initially shorter than the main menu.
        var mainMenuHeight = $('.header__nav-main .menu--main').outerHeight();
        $('.header__nav-actions .menu--tools').height(mainMenuHeight);
        $('.header__nav-actions .menu--search').height(mainMenuHeight);
        $('.header__nav-anon .menu--user').height(mainMenuHeight);
        $('aside.branding').height(mainMenuHeight);

      }, 400));
    }
  };

  /*
   * Submenu
   */
  Drupal.behaviors.navigationSubmenu = {
    attach: function (context) {
      var fadeDuration = 125;
      // Main menu item links act as triggers for submenu targets.
      $('.menu--main .menu__item a, .menu--main .menu__item span', context).hoverIntent(function () {
        var $main_menu_items = $('.menu--main .menu__item');
        var $main_item = $(this).parent('.menu__item');
        var $navbar = $main_item.closest('.navigation');
        var $navheader = $navbar.parent('.site__header');
        var $target = $main_item.attr('data-submenu-target');
        var $submenu = $('[data-submenu="' + $target + '"]', $navheader);
        // Reset the old hover classes, prior assigning new one.
        $main_menu_items.removeClass('menu__item--is-open').attr('aria-expanded', 'false');
        // Assigning active class.
        $main_item.addClass('menu__item--is-open').attr('aria-expanded', 'true');
        if ($submenu.length > 0) {
          // -- clear any existing timer
          clearTimeout($submenu.data('hoverTimer'));

          // -- fade in the submenu
          $submenu.stop(true, true).fadeIn(fadeDuration).attr('data-submenu-open', 'true');
        }
      }, function () {
        var $main_item = $(this).parent('.menu__item');
        var $navbar = $main_item.closest('.navigation');
        var $navheader = $navbar.parent('.site__header');
        var $target = $main_item.attr('data-submenu-target');
        var $submenu = $('[data-submenu="' + $target + '"]', $navheader);
        if ($submenu.length > 0) {
          // -- set a timer
          var timer = setTimeout(function () {
            $submenu.stop(true, true).fadeOut(fadeDuration).removeAttr('data-submenu-open');
            $main_item.removeClass('menu__item--is-open').attr('aria-expanded', 'false');
          }, 400);
          $submenu.data('hoverTimer', timer);
        }
        else {
          $('.menu--main .menu__item').removeClass('menu__item--is-open').attr('aria-expanded', 'false');
        }
      });

      // Hover the submenu, clear the hoverTimer.
      $('.submenu__item[data-submenu]', context).hover(function () {
        var $t = $(this);
        // -- clear timer
        clearTimeout($t.data('hoverTimer'));

        // -- swap navbar classes conditionally
        var $navbar = $t.closest('.submenu').siblings('.navigation');
        if ($navbar.attr('data-nav-overlay') === 'true' && !$navbar.attr('data-nav-scrolling')) {
          var actionClasses = navbarActionClasses($navbar);
          $navbar
            .addClass(actionClasses.on)
            .removeClass(actionClasses.off);
        }
      }, function () {
        var $t = $(this);
        // -- fade out when no longer hovering
        $t.stop(true, true).fadeOut(fadeDuration).removeAttr('data-submenu-open');

        // -- swap navbar classes conditionally
        var $navbar = $t.closest('.submenu').siblings('.navigation');
        if ($navbar.attr('data-nav-overlay') === 'true' && !$navbar.attr('data-nav-scrolling')) {
          var actionClasses = navbarActionClasses($navbar);
          $navbar
            .removeClass(actionClasses.on)
            .addClass(actionClasses.off);
        }
        $('.menu--main .menu__item').removeClass('menu__item--is-open').attr('aria-expanded', 'false');
      });

      // Keyboard enter the submenu, clear the hoverTimer.
      $('.menu--main .menu__item a, .menu--main .menu__item span', context).on('keyup', function (e) {
        var keycode = e.keyCode || e.which;
        var $main_menu_items = $('.menu--main .menu__item');
        var $main_item = $(this).parent('.menu__item');
        var $navbar = $main_item.closest('.navigation');
        var $navheader = $navbar.parent('.site__header');
        var $target = $main_item.attr('data-submenu-target');
        var $submenu = $('[data-submenu="' + $target + '"]', $navheader);
        var $submenu_items = $('.submenu__item.menu--submenu');

        if (keycode === 13) {
          // Reset the old hover classes, prior assigning new one.
          $main_menu_items.removeClass('menu__item--is-open').attr('aria-expanded', 'false');
          $submenu_items.hide().removeAttr('data-submenu-open');
          // Assigning active class.
          $main_item.addClass('menu__item--is-open').attr('aria-expanded', 'true');

          if ($submenu.length > 0) {
            // -- fade in the submenu
            $submenu.stop(true, true).fadeIn(fadeDuration).attr('data-submenu-open', 'true');
            $submenu.find('.submenu__item-inner').attr('tabindex', '0').focus();
          }
        }
      });
    }
  };

  /*
   * Mobile
   */
  Drupal.behaviors.navigationMobile = {
    attach: function (context) {
      var $toggle = $('.menu__toggle', context);
      var target = $toggle.attr('data-menu-target');
      var targetEl = '.' + target;
      var $navigation_inner = $('.navigation__inner');
      var $content = $('.site__content, .site__footer');
      var wSTop = 0;
      var $navbar = $('.navigation');
      var $menuSearch = $('.menu--search', context);

      $toggle.click(function () {
        var $this = $(this);
        var $toggleText = $this.find('.menu__toggle-text');
        // Display the content and footer when the hamburger nav gets closed.
        if (isMobileMenuOpen) {
          $content.show();
          window.scrollTo(0, wSTop);
        }
        $this
          .toggleClass('menu__toggle--collapsed')
          .toggleClass('menu__toggle--open');

        if (!$menuSearch.length) {
          // prevent body behind mobile menu from scrolling
          $this.closest('body').toggleClass('u-noscroll');
        }

        isMobileMenuOpen = !isMobileMenuOpen;
        $(targetEl).slideToggle('fast', function () {

          // Save the window position and hide the content with footer to avoid
          // the double scroll glitch.
          if (isMobileMenuOpen) {
            wSTop = window.scrollY;
            $content.hide();
            $navbar.removeClass('navigation--trans-bg').addClass('navigation--white-bg');
          }
        });

        // Change the text of the menu toggle for screen readers.
        if (isMobileMenuOpen) {
          $toggleText.text(Drupal.t('Close menu'));
        }
        else {
          $toggleText.text(Drupal.t('Open menu'));
        }

        if (!$menuSearch.length) {
          // toggle navigation inner.
          $navigation_inner.toggleClass('collapsed');
        }
      });

      // Autoclose mobile naviagation when screen width exceeds 1024px.
      $(window).resize(function () {
        if ($(window).width() > 1024) {
          if ($navigation_inner.hasClass('collapsed')) {
            $('.menu__toggle').trigger('click');
          }
        }
      });
    }
  };

  /*
   * Manage user menu
   */
  Drupal.behaviors.userMenuNav = {
    attach: function (context, settings) {

      // Check for user sessionStorage.
      var $user_session_data = JSON.parse(sessionStorage.getItem('pin_pinterest_authusers.user'));

      if ($user_session_data === null || settings.pin_user_nav_blocks.pinUserScripts.menuOutput === null) {
        return;
      }

      // Get the user menu from drupal settings.
      var $user_menu = $.parseHTML(settings.pin_user_nav_blocks.pinUserScripts.menuOutput);

      // Format the user menu.
      $($user_menu).find('li').addClass('menu__item');

      // Default avatar.

      var $user_avatar = 'https://s.pinimg.com/images/user/default_75.png';
      if ($user_session_data.img && $user_session_data.img.length > 0) {
        // If images exist, use the first one listed.
        $user_avatar = $user_session_data.img;
      }

      // Set the user object.
      var $user = {
        username: Drupal.checkPlain($user_session_data.un),
        name: Drupal.checkPlain($user_session_data.fn),
        avatar: Drupal.checkPlain($user_avatar),
        alt: Drupal.checkPlain($user_session_data.fn) + ' ' + Drupal.checkPlain($user_session_data.ln)
      };
      // Truncate long names to not break layout.
      $user.shortname = ($user.name).length > 29 ? jQuery.trim($user.name).substring(0, 29) + '...' : $user.name;

      // Create markup for header user menu items.
      var $markup = '<div class="user__profile">'
          + '<a href="https://pinterest.com/' + $user.username + '">'
          + '<span class="user__profile__avatar"><img alt="' + $user.alt + '" src="' + $user.avatar + '"></span>'
          + '<span class="user__profile__name">' + $user.shortname + '</span>'
          + '</a></div>'
          + '<button class="menu__user__toggle menu__user__toggle--collapsed" data-menu-target="menu-user-authenticated">'
          + '<span class="menu__user__toggle-text">User Menu</span>'
          + '</button>';

      // Replace the anonymous user menu with authenticated one.
      $('#block-headernavigationanon', context).after($user_menu).replaceWith($markup);

      // Toggle behavior for show/hide of user menu on desktop.
      var isUserMenuOpen = false;
      var $toggle = $('.menu__user__toggle', context);
      var target = $toggle.attr('data-menu-target');
      var targetEl = '.' + target;
      // Toggle user menu function.
      $toggle.click(function () {

        $(this)
          .toggleClass('menu__user__toggle--collapsed')
          .toggleClass('menu__user__toggle--open');

        isUserMenuOpen = !isUserMenuOpen;
        $(targetEl).slideToggle('fast', function () {

        });
      });
      // Auto-close user menu when screen width is less than 1024px.
      $(window).resize(function () {
        if ($(window).width() < 1024) {
          if ($toggle.hasClass('menu__user__toggle--open')) {
            $toggle.trigger('click');
          }
        }
      });
    }
  };

  /*
   * Mobile help-center-mobile-nav
   */
  Drupal.behaviors.userMobile = {
    attach: function (context) {
      var $mobileMenu = $('.menu--mobile', context);
      var $userMenu = $('.menu--user', context);
      var $userProfile = $('.user__profile');
      // Check for mobile and user menus.
      if ($mobileMenu.length && $userMenu.length) {
        // Clone the user menu and update classes.
        var $userMenuMobile =
          $userMenu
            .clone()
            .removeClass()
            .addClass('mobile-user-menu');
        // If logged in, add the user profile menu.
        if ($userProfile.length) {
          $userProfile
            .clone()
            .addClass('mobile')
            .wrap("<li class='menu__item'></li>")
            .parent()
            .prependTo($userMenuMobile);
        }
        // Add the mobile version of the user menu to the mobile menu.
        $userMenuMobile
          .wrap("<li class='menu__item'></li>")
          .parent()
          .appendTo($mobileMenu);
      }
    }
  };

}(jQuery, Drupal, _));
